import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/waste';
import { modalErrorOpen } from '../actions/modalError';
import { get } from '../../utils/api';

export function* getWasteRolls({ payload }) {
  try {
    const response = yield call(get, `/grid/production/balancing/semi_product?dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}&plantId=${payload.plantId}`);
    yield put(action.getWasteRollsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      }),
    );
    yield put(action.getWasteRollsFail());
  }
}
